import React, { useState, useRef, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import nextImg from "../../assets/images/side-icon.svg";
import nextImg1 from "../../assets/images/side-icon2.svg";
import Navinner from "../../components/nav-inner";
import Innerfooter from "../../components/inner-footer";
import Innerpagenavbar from "../../components/innerpage-navbar";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { Editor } from "@tinymce/tinymce-react";
import { toastAlert } from "../../utils/toast";

//API
import {
  getConfirmMessage,
  registerConfirmMessage,
  submitEmailTemplate,
} from "../../action/user.action";
import { decryptString } from "../../helper/helper";

const RegistrationPageOne = () => {
  const { id } = useParams();
  //Ref
  const editorRef = useRef(null);
  //State
  const [email, setEmail] = useState(false);
  const [show, setShow] = useState(false);
  const [templateData, setTemplateData] = useState(
    `<p>&nbsp;</p><table align=\"center\" border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"padding: 0px;    background: url('https://lokalcoin.com/static/cms_images/emailBg.jpg') 0px 0px no-repeat scroll #121a23;    max-width: 650px; height: 381px; width: 100%;\" width=\"100%\"><tbody><tr style=\"height: 38px;\">            <td style=\"height: 38px;\"><table border=\"0\" cellpadding=\"0\" cellspacing=\"0\"                    style=\"margin: 0; padding: 15px;\" width=\"100%\"><tbody><tr>                            <td><a href=\"##SITE_URL##\"><img src=\"##EMAIL_LOGO##\" /></a></td>                            </tr></tbody></table></td></tr><tr            style=\"height: 21px;\"><td height=\"10\" style=\"height: 21px;\">&nbsp;</td></tr>        <tr style=\"height: 168px;\"><td style=\"height: 168px;\"><table align=\"center\"                    border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"margin: 0px auto; background: rgba(26,                    36, 47, 0.7); padding: 20px; height: 286px;\" width=\"95%\"><tbody><tr>                            <td style=\"margin: 0; padding: 0;\"><p style=\"font-family:                                    Arial, Helvetica, sans-serif; margin: 0 0 15px 0; padding: 0; color: #ffffff;                                    font-size: 12px; font-weight: normal;\">Dear valued User,</p>                                <p style=\"font-family: Arial, Helvetica, sans-serif; margin: 0 0                                    5px 0; padding: 0; color: #ffffff; font-size: 14px; font-weight: normal;\">You                                    have successfully register to :.                                </p><p style=\"font-family: Arial, Helvetica, sans-serif; margin: 0;                                    padding: 0; color: #ffffff; font-size: 12px; font-weight: normal; line-height:                                    20px;\">Thanks &amp;                                    Regards,                                    <br />##WEBINAR_NAME##.                                    <br />##WEBINAR_SESSION##.                                </p>                                <p                                 </p><p </p>                                                                    <p style=\"font-family: Arial, Helvetica, sans-serif; margin: 0 0 5px 0; padding: 0;                                    color: #ffffff; font-size: 14px; font-weight: normal;\"><a                                        href=\"##templateInfo_url##\" rel=\"noopener\" style=\"display: block;                                        text-decoration: underline; margin-top: 5px; color: rgba(214, 176, 50, 1)\"                                        target=\"_blank\">Meeting Link</a></p><p                                    style=\"font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; color:                                    #ffffff; font-size: 12px; font-weight: normal; line-height: 20px;\">Thanks &amp;                                    Regards,<br />##SITE_NAME## Support Team.</p><p                                    style=\"font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; color:                                    #ffffff; font-size: 12px; font-weight: normal; line-height: 20px;\">&nbsp;</p>                                <p style=\"font-family: Arial, Helvetica, sans-serif; margin: 0;                                    padding: 0; color: #ffffff; font-size: 12px; font-weight: normal; line-height:                                    20px;\">##ANTIPHISHINGCODE##</p>                            </td></tr>                        <tr></tr>                    </tbody></table></td></tr><tr style=\"height: 21px;\"><td                height=\"5\" style=\"height: 21px;\">&nbsp;</td></tr><tr style=\"height: 64px;\">            <td style=\"margin: 0px; padding: 12px 0px; text-align: center; font-size: 12px; color: #aeaeae;                font-family: Arial, Helvetica, sans-serif; height: 64px;\">                <strong>##SITE_NAME## Private Limited</strong><br />Address:                ##ADDRESS##<br />Contact : ##CONTACT_NO##<br />Email : <a                    href=\"mailto:##SUPPORT_MAIL##\" rel=\"noopener\" style=\"color: #aeaeae; text-decoration:                    none;\" target=\"_blank\">##SUPPORT_MAIL##</a>            </td></tr><tr style=\"height: 48px;\">            <td style=\"margin: 0px; padding: 0px 0px 7px; text-align: center; font-size: 12px; color:                #d69f2b; font-family: Arial, Helvetica, sans-serif; height: 48px;\">Join our community<p                    style=\"font-size: 0; line-height: 0; padding: 0; margin: 10px 0 0 0;\"><a                        href=\"##TWITER_LINK##\" rel=\"noopener\" target=\"_blank\"><img height=\"20\"                            src=\"##TWITER_LOGO##\" width=\"25\" /></a> <a href=\"##LINKEDIN_LINK##\"                        rel=\"noopener\" style=\"margin: 0 15px 0 12px;\" target=\"_blank\"><img height=\"18\"                            src=\"##LINKED_IN_LOGO##\" width=\"22\" /></a> <a href=\"##FB_LINK##\" rel=\"noopener\"                        target=\"_blank\"><img height=\"22\" src=\"##FB_LOGO##\" width=\"29\" /></a></p>            </td></tr><tr style=\"height: 21px;\"><td height=\"10\" style=\"height: 21px;\">                &nbsp;</td></tr>    </tbody></table>`
  );
  const [responseData, setResponseData] = useState(null);

  const [decryptStr, setDecryptString] = useState();
  const [uses, setUses] = useState(null);

  //function
  const handleEmailClose = () => setEmail(false);
  const handleEmailShow = () => setEmail(true);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const registerConfirmMessage = async (uses) => {
    setUses(uses);
    // handleEmailShow();
    const decodeid = await decryptString(id, true);
    const payload = {
      id: decodeid,
      name: uses,
    };
    const { status, result } = await getConfirmMessage(payload);
    setResponseData(result);
    if (status) {
      setTemplateData(result?.result?.content);
      handleEmailShow();
    }
  };

  const decodeFun = async () => {
    console.log(id, "iiiiii");

    const decodeid = await decryptString(id, true);

    console.log(decodeid, "decodeid");

    setDecryptString(decodeid);
  };
  useEffect(() => {
    decodeFun();
  }, [id]);

  const handleSubmit = async (e) => {
    if (editorRef.current) {
      const payload = {
        id: responseData?.result?._id,
        name: uses,
        content: editorRef.current.getContent(),
      };
      const { status, result } = await submitEmailTemplate(payload);
      if (status) {
        toastAlert("success", "Submitted");
        handleEmailClose();
      }
    }
  };

  return (
    <>
      <div className="dashboard-page">
        <div className="dashboard">
          <Innerpagenavbar />
          <div className="dashbord-right mt-5 mb-5">
            <div className="registration_nav_sec">
              <ul className="registration_list">
                <li>
                  <div className="registration_nav_content">
                    <img
                      src={require("../../assets/images/registration_imgs/notepad.png")}
                      className="img-fluid"
                    />
                    <p>Configuration</p>
                    {id ? (
                      <img
                        src={require("../../assets/images/registration_imgs/checked.png")}
                        className="img-fluid"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </li>

                <li>
                  <div className="registration_nav_content">
                    <img
                      src={require("../../assets/images/registration_imgs/calendar-tick.png")}
                      className="img-fluid"
                    />
                    <p>Schedules</p>
                    {id ? (
                      <img
                        src={require("../../assets/images/registration_imgs/checked.png")}
                        className="img-fluid"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </li>
                {/* <li>
                                                    <div className="registration_nav_content">
                                                        <img
                                                            src={require("../../assets/images/registration_imgs/driver.png")}
                                                            className="img-fluid"
                                                        />
                                                        <p>Registration</p>
                                                    </div>
                                                </li> */}
                <li>
                  <div className="registration_nav_content">
                    <img
                      src={require("../../assets/images/registration_imgs/notification_2.png")}
                      className="img-fluid"
                    />
                    <p>Notification</p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="dashbord-right-body">
              <div className="dashbordrightbody-header">
                <p>Email - Notification</p>
                <div>
                  {/* <ul>
                    <li>
                      <a href="#">Edit</a>
                    </li>
                    <li>
                      <a href="#">Clone</a>
                    </li>
                    <li>
                      <a href="#">Delete</a>
                    </li>
                  </ul> */}
                </div>
              </div>
              <div className="dashbordrightbody-body">
                <div className="dashbordrightbody-list1 registration_alert">
                  <h6>
                    All emails notifications will be sent out from{" "}
                    <span>"Kevin Peterson - kevin@peterson.com"</span>. If you'd
                    like to change it, read this article.
                  </h6>
                  <div className="pre_notification">
                    <ul className="pre_notification_list">
                      <li className="list_msg">
                        <h4 className="mb-2">Pre-Webinar notifications</h4>
                        <p>
                          Keep them in the loop of the webinar they've
                          registered for, It's a great opportunity to hand them
                          their link to the webinar room, and to remind them of
                          the topics that will be covered. It helps greatly to
                          maximize attendance!
                        </p>
                        <ul className="pre_notification_1 mt-3">
                          <li>
                            <div className="confirm_msg">
                              <div className="add_info">
                                <h4>Register Confirmation Message</h4>
                                {/* <div className="add_info_span">
                                  <a href="#">Add Phone</a>
                                  <a href="#">Add Email</a>
                                </div> */}
                              </div>
                              <div className="confirm_msg_content mt-4">
                                <div className="add_info_content">
                                  <img
                                    src={require("../../assets/images/registration_imgs/msg.png")}
                                    className="img-fluid"
                                  />
                                  <div>
                                    <h4>Immediately</h4>
                                    <p>[Confirmation] Your webinar link</p>
                                  </div>
                                </div>
                                <div className="add_info_img">
                                  <img
                                    src={require("../../assets/images/registration_imgs/pencil.png")}
                                    className="img-fluid"
                                    onClick={() =>
                                      registerConfirmMessage("User_Register")
                                    }
                                  />

                                  {/* <a href="#">
                                    {" "}
                                    <img
                                      src={require("../assets/images/registration_imgs/mail.png")}
                                      className="img-fluid"
                                    />
                                  </a>                                  
                                  <a href="#">
                                    {" "}
                                    <img
                                      src={require("../assets/images/registration_imgs/wrong.png")}
                                      className="img-fluid"
                                    />
                                  </a> */}
                                </div>
                              </div>
                            </div>
                          </li>
                          {/* <li>
                            <div className="confirm_msg">
                              <div className="add_info">
                                <h4>Register Confirmation Message</h4>
                                <div className="add_info_span">
                                  <a href="#">Add Phone</a>
                                  <a href="#">Add Email</a>
                                </div>
                              </div>
                            </div>
                          </li> */}
                          <li>
                            <div className="confirm_msg">
                              <div className="add_info">
                                <h4>Remainder Confirmation Message</h4>
                                {/* <div className="add_info_span">
                                  <a href="#">Add Phone</a>
                                  <a href="#">Add Email</a>
                                </div> */}
                              </div>
                              <div className="confirm_msg_content mt-4">
                                <div className="add_info_content">
                                  <img
                                    src={require("../../assets/images/registration_imgs/msg.png")}
                                    className="img-fluid"
                                  />
                                  <div>
                                    <h4>Immediately</h4>
                                    <p>[Confirmation] Your webinar link</p>
                                  </div>
                                </div>
                                <div className="add_info_img">
                                  <img
                                    src={require("../../assets/images/registration_imgs/pencil.png")}
                                    className="img-fluid"
                                    onClick={() =>
                                      registerConfirmMessage("Reminder_Notify")
                                    }
                                  />

                                  {/* <a href="#">
                                    {" "}
                                    <img
                                      src={require("../assets/images/registration_imgs/mail.png")}
                                      className="img-fluid"
                                    />
                                  </a>
                                  <a href="#">
                                    <img
                                      src={require("../assets/images/registration_imgs/pencil.png")}
                                      className="img-fluid"
                                    />
                                  </a>
                                  <a href="#">
                                    {" "}
                                    <img
                                      src={require("../assets/images/registration_imgs/wrong.png")}
                                      className="img-fluid"
                                    />
                                  </a> */}
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="list_msg">
                        <h4>Post Webinar notifications</h4>
                        <p>
                          Follow up with them to hand them the link to the
                          webinar replay in case they missed it, or remind them
                          of your product and sevices. this is also great
                          opportunity to invite them to another webinar event!
                        </p>
                        <ul className="pre_notification_1">
                          <li>
                            <div className="confirm_msg">
                              <div className="add_info">
                                <h4>Post Webinar follow ups</h4>
                                <div className="add_info_span">
                                  <a href="#">Add Phone</a>
                                  <a href="#">Add Email</a>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <Link
                    to="/webinar"
                    className="primary_btn"
                    onClick={handleShow}
                  >
                    <img
                      src={require("../../assets/images/chevron-right.png")}
                      height="16"
                      width="16"
                      className="img-fluid"
                    />
                    Finished
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="popup1">
          <Modal
            size="md"
            show={show}
            onHide={handleClose}
            keyboard={false}
            className="registration_modal"
          >
            <Modal.Header className="model-head" closeButton></Modal.Header>
            <Modal.Body>
              <div className="modal_msg">
                <img
                  src={require("../../assets/images/registration_imgs/modal_img.png")}
                  alt="img"
                  className="img-fluid mx-auto d-block mb-4"
                />
                <h4>Congratulations!</h4>
                <p>Your webinar has been successfully created!</p>
                <div className="modal_button mt-4">
                  <Link to="#" className="primary_btn">
                    <img
                      src={require("../../assets/images/chevron-right.png")}
                      height="16"
                      width="16"
                      className="img-fluid"
                    />
                    Go to Dashboard
                  </Link>
                </div>
              </div>
            </Modal.Body>
            {/* <Modal.Footer className="footer-model">
       
        <img
                src={nextImg}
                alt="img"
                className="img-fluid"
              />
            <img
                src={nextImg1}
                alt="img"
                className="img-fluid"
              />   
       
        </Modal.Footer> */}
          </Modal>
        </div>

        <Modal
          size="lg"
          show={email}
          onHide={handleEmailClose}
          keyboard={false}
          centered
          className="emailnotifications"
        >
          <Modal.Header className="model-head">
            <Modal.Title className="model-title">
              Email Notifications
            </Modal.Title>
            <div>
              <Link
                to="#"
                className="primary_btn primary_btn2 me-4"
                onClick={handleEmailClose}
              >
                <svg
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.5 1L6.5 6L1.5 11"
                    stroke="#001F2A"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Cancel
              </Link>
              <button
                className="primary_btn"
                type="button"
                onClick={(e) => handleSubmit(e)}
              >
                {/* <img
                src={require("../../assets/images/chevron-right.png")}
                height="16"
                width="16"
                className="img-fluid"
              />{" "} */}
                Confirm
              </button>
            </div>
          </Modal.Header>
          <Modal.Body className="mailnotify-body">
            <div className="mail-head">
              <Row>
                <Col lg="12">
                  {" "}
                  <Form.Label htmlFor="inputPassword5">Webinar name</Form.Label>
                  <Form.Control
                    disabled={true}
                    type="text"
                    id="inputPassword5"
                    placeholder="[confirmation] Your webinar link"
                    aria-describedby="passwordHelpBlock"
                    value={responseData?.webinarDetails?.Webinar_title}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <p>Email body</p>
                  {/* <img
                  src={require("../../assets/images/email-body.png")}
                  className="img-fluid pt-2"
                />{" "} */}
                  <Editor
                    apiKey="limjfdlb66u3w96h1skw5m93kdvmf55zt4ohb3ol4jeb3q6m"
                    cloudChannel="5-stable"
                    disabled={false}
                    initialValue={templateData}
                    inline={false}
                    onInit={(_evt, editor) => (editorRef.current = editor)}
                    //onEditorChange={(e)=>console.log(e.target.value)}
                    //onChange={(e)=>console.log(e.target.getContent())}
                    plugins=""
                    tagName="div"
                    textareaName=""
                    toolbar=""
                    value=""
                    outputFormat="html"
                    init={{
                      height: 500,
                      language: "en",
                      menubar: true,
                      plugins: [
                        "advlist autolink lists link image charmap print preview anchor",
                        "searchreplace visualblocks code fullscreen",
                        "insertdatetime media table paste code help wordcount",
                      ],
                      toolbar:
                        "undo redo | formatselect | bold italic backcolor | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | help",
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <Innerfooter />
    </>
  );
};
export default RegistrationPageOne;
